var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickerLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 996,
    height: 264,
    viewBox: "0 0 996 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 232C187.228 232 232 187.228 232 132C232 76.7715 187.228 32 132 32C76.7715 32 32 76.7715 32 132C32 187.228 76.7715 232 132 232Z",
    fill: "url(#paint0_linear_275_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.29 98.96L172.052 98.7213C167.243 93.9123 159.398 93.9123 154.589 98.7213L114.412 138.899L104.998 129.485C100.121 124.608 92.2084 124.608 87.2971 129.485C82.4199 134.362 82.4199 142.275 87.2971 147.186L105.442 165.331L105.68 165.57C110.489 170.379 118.334 170.379 123.143 165.57L123.245 165.468L172.256 116.457C177.065 111.648 177.065 103.803 172.256 98.9941L172.29 98.96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.513 211.678V80.9375H272V52.0008H385.598V80.9375H345.728V211.678H312.503H312.513Z",
    fill: "#2D0909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.915 211.677C501.2 211.677 490.653 208.993 481.304 203.636C471.946 198.278 464.509 190.96 459.013 181.671C453.507 172.382 450.763 161.954 450.763 150.377C450.763 138.8 453.477 128.412 458.904 119.192C464.331 109.973 471.768 102.724 481.196 97.4354C490.623 92.1471 501.2 89.503 512.915 89.503C521.63 89.503 529.701 91.0083 537.138 93.999C544.565 96.9996 550.923 101.179 556.211 106.536C561.499 111.894 565.282 118.222 567.57 125.501L539.703 137.503C537.702 131.65 534.306 127.006 529.522 123.57C524.729 120.143 519.194 118.43 512.915 118.43C507.34 118.43 502.378 119.787 498.021 122.5C493.663 125.213 490.227 129.006 487.732 133.859C485.226 138.721 483.978 144.287 483.978 150.575C483.978 156.864 485.226 162.439 487.732 167.292C490.227 172.154 493.663 175.937 498.021 178.65C502.378 181.364 507.349 182.72 512.915 182.72C519.342 182.72 524.917 181.007 529.631 177.581C534.345 174.154 537.702 169.51 539.703 163.647L567.57 175.868C565.431 182.73 561.707 188.87 556.429 194.297C551.141 199.734 544.783 203.982 537.356 207.052C529.928 210.122 521.778 211.657 512.925 211.657L512.915 211.677Z",
    fill: "#2D0909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M702.991 89.5332H663.339L618.577 136.771V52.0006H586.422V211.677H618.577V175.858L631.5 161.776L661.229 211.677H697.663L655.436 141.811L702.991 89.5332Z",
    fill: "#2D0909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M773.755 89.5426C765.615 89.5426 758.574 91.2955 752.642 94.7913C748.136 97.4552 744.6 101.961 742.035 108.289V89.503H712.029V211.677H744.174V144.841C744.174 136.127 746.601 129.373 751.463 124.59C756.316 119.806 762.683 117.41 770.536 117.41H780.608V89.5426H773.745H773.755Z",
    fill: "#2D0909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.898 89.5128H399.743V211.687H431.898V89.5128Z",
    fill: "#2D0909"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M431.898 51.9998H399.743V80.9365H431.898V51.9998Z",
    fill: "#2D0909"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M918.079 212H895.403L879.233 164.897H826.779L810.61 212H788.129L843.54 52.1076H862.668L918.079 212ZM949.86 211.958H931.548V108.051H949.86V211.958ZM834.273 143.506H871.936L853.4 82.3576H853.006L834.273 143.506ZM939.477 53.5451C939.845 51.5725 942.42 51.5725 942.788 53.5451C945.333 67.1847 949.259 71.4859 961.707 74.2746C963.508 74.6781 963.508 77.5001 961.707 77.9035C949.259 80.6922 945.333 84.9935 942.788 98.633C942.42 100.606 939.845 100.606 939.477 98.633C936.932 84.9936 933.006 80.6922 920.558 77.9035C918.758 77.5002 918.758 74.6779 920.558 74.2746C933.006 71.4859 936.932 67.1846 939.477 53.5451Z",
    fill: "url(#paint1_linear_275_45)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_45",
    x1: 61.2633,
    y1: 61.2974,
    x2: 202.703,
    y2: 202.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A72B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_45",
    x1: 788.129,
    y1: 52.1074,
    x2: 964.983,
    y2: 209.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235577,
    stopColor: "#FDC80E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "#9898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846154,
    stopColor: "#EB513B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickerLogo4);
export default __webpack_public_path__ + "static/media/TickerLogo4.ffd2aca34f02364ea5b00f535dc61fe8.svg";
export { ForwardRef as ReactComponent };